import { useEffect, useRef, useState } from "react";
import { entryItems } from "@/mocks/home";

export default function EntryPanel() {
  const [toast, setToast] = useState("");
  const timerRef = useRef<number | null>(null);

  useEffect(
    () => () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    },
    []
  );

  const showToast = (text: string) => {
    setToast(text);
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }
    timerRef.current = window.setTimeout(() => setToast(""), 2400);
  };

  return (
    <section id="entry" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="rounded-lg bg-foreground-950 px-5 py-10 md:px-12 md:py-16">
          <div className="max-w-2xl mb-9 md:mb-12">
            <p className="font-label text-xs tracking-[0.2em] text-primary-300 mb-3">
              入口 / 下载
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug mb-4">
              想直接进去看，就从这里往下点
            </h2>
            <p className="text-sm md:text-base leading-7 text-background-300">
              三个入口分别对应合集、字幕版和浓缩版，挑你习惯的那种进。下载按整期打包，方便一次存下来慢慢看。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {entryItems.map((item) => (
              <div
                key={item.title}
                className="flex flex-col h-full rounded-lg border border-background-50/15 bg-background-50/5 p-5 md:p-6"
              >
                <span className="inline-flex items-center h-7 px-3 rounded-full bg-primary-500 text-background-50 text-xs font-label whitespace-nowrap self-start mb-4">
                  {item.note}
                </span>
                <h3 className="font-heading text-lg font-bold text-background-50 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm leading-6 text-background-300 flex-1">
                  {item.summary}
                </p>
                <button
                  type="button"
                  onClick={() => showToast(`已打开「${item.title}」入口（展示效果）`)}
                  className="mt-6 inline-flex items-center justify-center gap-2 h-10 rounded-md bg-background-50 text-foreground-950 text-sm font-label whitespace-nowrap hover:bg-accent-200 transition-colors cursor-pointer"
                >
                  {item.action}
                  <i className="ri-arrow-right-up-line" />
                </button>
              </div>
            ))}
          </div>

          <div className="mt-6 md:mt-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 rounded-lg border border-background-50/15 px-5 py-5">
            <div className="flex items-start gap-3">
              <span className="w-9 h-9 rounded-full bg-accent-500 text-foreground-950 flex items-center justify-center shrink-0">
                <i className="ri-download-cloud-2-line" />
              </span>
              <div>
                <p className="font-heading text-base font-bold text-background-50">
                  下载浓缩版打包（本期 26 条）
                </p>
                <p className="text-xs md:text-sm text-background-400 mt-1">
                  按条目整理好，方便离线保存；仅作展示，不接真实下载。
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => showToast("下载入口为展示效果，暂未接通")}
              className="inline-flex items-center justify-center gap-2 h-10 px-6 rounded-md bg-accent-500 text-foreground-950 text-sm font-label whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer shrink-0"
            >
              <i className="ri-download-2-line" />
              下载本期
            </button>
          </div>
        </div>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-4">
          <div className="flex items-center gap-2 rounded-md bg-foreground-950 text-background-50 text-sm font-label px-4 py-2.5 shadow-sm">
            <i className="ri-information-line text-primary-300" />
            <span className="whitespace-nowrap">{toast}</span>
          </div>
        </div>
      )}
    </section>
  );
}